import styled from 'styled-components/native';
import { RFValue} from 'react-native-responsive-fontsize';
import FastImage from '../../components/Interface/Images/FastImageWithFallback';
import LinearGradient from 'react-native-linear-gradient';
import Icon from 'react-native-vector-icons/Feather';
import Svg, {Circle, Line} from 'react-native-svg';
import React from 'react';
import { ColorSchemeName, Dimensions, Platform } from 'react-native';

/**
 * Tamanho base do QR Code. Altere apenas este valor para
 * redimensionar todo o bloco (frame, viewport, carousel e SVG).
 */

const SCREEN_W = Dimensions.get('window').width;
const SCREEN_H = Dimensions.get('window').height;


export const QR_SIZE = Platform.OS === 'web' ? Math.round(Math.min(SCREEN_W * 0.40, SCREEN_H * 0.40)) : Math.round(Math.min(SCREEN_W * 0.45, SCREEN_H * 0.45));
export const QR_FRAME = RFValue(QR_SIZE);
export const QR_VIEWPORT = RFValue(QR_SIZE + 10);
export const QR_SVG = RFValue(Math.round(QR_SIZE * 0.90));

//@ts-ignore
export const Container = styled(LinearGradient)`
  flex: 1;
  
`;

const ContentPaddingCalc = () => {
  if (SCREEN_W >= 430) {return RFValue(16);}   // iPhone Pro Max, large Android
  if (SCREEN_W >= 390) {return RFValue(12);}   // iPhone 14/15/16 Pro
  if (SCREEN_W >= 375) {return Platform.OS === 'ios' ? RFValue(32) : RFValue(4);}   // iPhone 13 mini, SE 3rd
  if(SCREEN_W >= 360) {return RFValue(12);}   // Small Android

  if(SCREEN_W >= 344) {return RFValue(0);}   // Small Android
  return RFValue(48);                          // Galaxy Nexus, SE 1st, small
};

const TopHeaderPadding = () => {
  if (SCREEN_W >= 430) {return RFValue(45);}   // iPhone Pro Max, large Android
  if (SCREEN_W >= 390) {return RFValue(45);}   // iPhone 14/15/16 Pro
  if (SCREEN_W >= 375) {return RFValue(45);}   // iPhone 13 mini, SE 3rd
  return RFValue(40);                          // Galaxy Nexus, SE 1st, small
};

export const Content = styled.View`
  
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: visible;
  z-index: 1;

  width: 100%;
  padding: 0 ${ContentPaddingCalc()}px;
`;

export const Wrapper = styled.View`

  align-items: center;
  width: 100%;
`;

export const QRCodeContainer = styled.View`
  align-items: center;
  justify-content: center;

  border-radius: ${RFValue(12)}px;
  width: 100%;
`;




export const TicketHeader = styled.ImageBackground`

  background-color: ${({theme}) => Platform.OS === 'web' ? theme.colors.background : undefined};
  padding-top: ${TopHeaderPadding()}px;
  width: 100%;
  padding-bottom: ${RFValue(0)}px;

`;

export const TickerPadding = styled.View`
  padding: 0 ${RFValue(24)}px;
   align-items: center;
  justify-content: center;
  width: 100%;
`;

export const TickerBottom = styled.ImageBackground`
  align-items: center;
  justify-content: center;
  margin-top: -${RFValue(0)}px;
  background-color: ${({theme}) => Platform.OS === 'web' ? theme.colors.background : undefined};
  width: 100%;
  padding-top: ${RFValue(8)}px;
  padding-bottom: ${RFValue(25)}px;
`;

export const TicketCompletion = styled.View`
  background-color: ${({theme}) => theme.colors.shape};
  width: 100%;
  padding-bottom: ${RFValue(30)}px;
  margin-top: -${RFValue(30)}px;
  z-index: 1;
`;


const DotCount = () => {
  if (SCREEN_W >= 430) {return 18;}   // iPhone Pro Max, large Android
  if (SCREEN_W >= 390) {return 22;}   // iPhone 14/15/16 Pro
  if (SCREEN_W >= 375) {return 21;}   // iPhone 13 mini, SE 3rd
  return 18;                          // Galaxy Nexus, SE 1st, small
};


const DIVIDER_DOT_COUNT = DotCount();
const DIVIDER_DOT_R = RFValue(3);
const DIVIDER_DOT_GAP = RFValue(8);
const DIVIDER_W =
  DIVIDER_DOT_COUNT * (DIVIDER_DOT_R * 2 + DIVIDER_DOT_GAP) - DIVIDER_DOT_GAP;
const DIVIDER_H = DIVIDER_DOT_R * 2;



export const TickerDivider = (colorScheme: string) =>
  React.createElement(
    Svg,
    {width: DIVIDER_W, height: DIVIDER_H, style: {alignSelf: 'center', zIndex: 2, backgroundColor: '#fff'}},
    ...Array.from({length: DIVIDER_DOT_COUNT}, (_, i) =>
      React.createElement(Circle, {
        key: i,
        cx: DIVIDER_DOT_R + i * (DIVIDER_DOT_R * 2 + DIVIDER_DOT_GAP),
        cy: DIVIDER_DOT_R,
        r: DIVIDER_DOT_R,
        fill: colorScheme === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.1)',

      }),
    ),
  );

export const GoBackButton = styled.TouchableOpacity`
  position: absolute;
  top: ${RFValue(26)}px; 
  left: ${RFValue(22)}px;

`;

export const GoBackImage = styled(FastImage)`
  width: ${RFValue(28)}px;
  height: ${RFValue(28)}px;
`;

export const CouponInformationContainer = styled.View`
  background-color: ${({theme}) => theme.colors.newCuponScreenBackgroundSecondary};
  padding: ${RFValue(12)}px;
  border-radius: ${RFValue(12)}px;
  width: 100%;
  justify-content: center;
  align-items: stretch;
  gap: ${RFValue(8)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const CouponInfoRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  gap: ${RFValue(8)}px;
`;

export const CouponInfoTitle = styled.Text`
  font-size: ${RFValue(12)}px;
  line-height: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const CouponInfoValue = styled.Text`
  font-size: ${RFValue(12)}px;
  line-height: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const DashedDivider = ({colorScheme}: {colorScheme: ColorSchemeName}) =>
  React.createElement(
    Svg,
    {height: 1, width: '100%'},
    React.createElement(Line, {
      x1: '0',
      y1: '0.5',
      x2: '100%',
      y2: '0.5',
      stroke: colorScheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
      strokeWidth: 1,
      strokeDasharray: '6,4',
    }),
  );


//@ts-ignore
export const VoucherImage = styled(FastImage)`
  width: ${RFValue(50)}px;
  height: ${RFValue(50)}px;
  margin-top: -${RFValue(45)}px;
  background-color: ${({theme}) => theme.colors.shape};
  border-radius: ${RFValue(40)}px;
  border: 4px solid ${({theme}) => theme.colors.shape};
`;

export const QRCodeHeader = styled.View`
  flex-direction: column;
  align-items: center;
  gap: ${RFValue(6)}px;
  margin-bottom: ${RFValue(6)}px;
`;

export const QRCodeHeaderTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(16)}px;
  text-align: center;
`;

export const QRCodeHeaderDescription = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  margin-bottom: ${RFValue(8)}px;
  text-align: center;
`;


export const QRCodeExpiryDate = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  margin-bottom: ${RFValue(8)}px;
  text-align: center;
`;

export const CountdownContainer = styled.View`
  padding: ${RFValue(2)}px ${RFValue(8)}px;
  background: ${({theme}) => theme.colors.primary};

  border-radius: ${RFValue(20)}px;
`;

export const CountdownTimer = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
    line-height: ${RFValue(16)}px;
`;

export const CarouselViewport = styled.View`
  width: ${QR_VIEWPORT}px;
  height: ${QR_VIEWPORT}px;
  margin: 0 ${RFValue(12)}px;
  margin-top: ${RFValue(4)}px;

  align-items: center;
  justify-content: center;
  border: 2px solid ${({theme}) => theme.colors.border};
  border-radius: ${RFValue(16)}px;
  background-color: ${({theme}) => theme.colors.background};
`;

export const CarouselItemPressable = styled.Pressable`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const QRCodeFrame = styled.View`
  width: ${QR_FRAME}px;
  height: ${QR_FRAME}px;
  align-items: center;
  justify-content: center;

  border-radius: ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.shape};
`;

export const CodeTypeSwitcher = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const CodeTypeButton = styled.TouchableOpacity`
  padding: ${RFValue(10)}px;
`;

export const CodeTypePrevious = styled(Icon)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const TitleCodeTypeButton = styled.TouchableOpacity``;

export const CodeType = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const CodeTypeNext = styled(Icon)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const AutContainer = styled.View`
  width: ${QR_FRAME}px;
  height: ${QR_FRAME}px;
  align-items: center;
  justify-content: center;
  
`;

export const QRCodeTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(12)}px;
  margin-top: ${RFValue(12)}px;
`;

export const QRCodeAutCodeContainer = styled.View`
  background: ${({theme}) => theme.colors.title};
  padding: ${RFValue(4)}px ${RFValue(12)}px;
  margin: ${RFValue(6)}px 0;
  border-radius: ${RFValue(20)}px;
`;

export const QRCodeAutCod = styled.Text`
  color: ${({theme}) => theme.colors.buttonTitle};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(14)}px;
  text-align: center;
`;

export const UserCodeWrapper = styled.View`
  width: 100%;
  justify-content: center;
  align-items: stretch;
`;

export const UserCodeContainer = styled.View`
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: ${RFValue(8)}px;
  padding: ${RFValue(10)}px;
  border: 2px dashed ${({theme}) => theme.colors.blue};
  margin-bottom: ${RFValue(12)}px;
`;

export const UserCodeTitleContainer = styled.View`
  background-color: ${({theme}) => theme.colors.newCuponScreenBackground};
  margin-bottom: -${RFValue(8)}px;
  padding: 0 ${RFValue(10)}px;
  align-self: center;
  z-index: 1;
`;

export const UserCodeTitle = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(12)}px;
  line-height: ${RFValue(16)}px;
`;

export const UserCode = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(12)}px;
  text-align: center;
  margin-top: ${RFValue(4)}px;
`;

export const FooterActionsContainer = styled.View`
  flex-direction: row;
  gap: ${RFValue(8)}px;
  width: 100%;
`;

export const ActionButton = styled.TouchableOpacity`
  flex: 1;
  flex-direction: row;
  gap: ${RFValue(6)}px;
  align-items: center;
  background-color: ${({theme}) => theme.colors.background};
  padding: ${RFValue(10)}px ${RFValue(10)}px;
  border-radius: ${RFValue(10)}px;
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
`;
export const ActionButtonIcon = styled(Icon)<{iconColor?: string}>`
  font-size: ${RFValue(18)}px;
  color: ${({iconColor, theme}) => iconColor || theme.colors.title};
`;
export const ActionButtonTitle = styled.Text`
  font-size: ${RFValue(9.8)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const LinkButtonLight = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.shape};
  border-style: solid;
`;

export const LinkButtonText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

export const SupportIssueButton = styled.TouchableOpacity`
  margin-top: ${RFValue(8)}px;
  overflow: hidden;
  width: 100%;
`;

export const SupportIssueGradient = styled(LinearGradient).attrs(({theme}) => ({
  colors: theme.colors.promo_marquee_bg,
  start: {x: 0, y: 0.2},
  end: {x: 1, y: 0.2},
}))`
  padding: ${RFValue(8)}px ${RFValue(8)}px;
  border-radius: ${RFValue(8)}px;
  align-items: center;
  width: 100%;
`;

export const SupportIssueText = styled.Text`
  color: #fff;
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(11)}px;
  text-align: center;
`;

export const ButtonContainer = styled.View`
  width: 100%;
`;

export const FeedbackButton = styled.TouchableOpacity`
  margin-top: ${RFValue(12)}px;
`;

export const FeedbackTitle = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(14)}px;
  text-align: center;
  text-decoration: underline;
  text-decoration-color: ${({theme}) => theme.colors.shape};
  margin-bottom: ${RFValue(6)}px;
`;

export const Footer = styled.View`
  position: absolute;
  overflow: visible;
  justify-content: flex-end;
  align-items: flex-end;
  bottom: 0;
  z-index: 2;
`;

export const LogoImage = styled(FastImage)`
  width: ${RFValue(28)}px;
  height: ${RFValue(28)}px;
`;

export const Overlay = styled.View`
  flex: 1;
  background-color: rgba(0, 0, 0, 0.8);
  justify-content: center;
  padding: 0 24px;
  align-items: center;
  z-index: 2;
`;

export const LockIcon = styled(Icon).attrs(({theme}) => ({
  name: 'lock',
  size: RFValue(40),
  color: theme.colors.shape,
}))`
  margin-bottom: ${RFValue(12)}px;
`;

//@ts-ignore
export const RefreshButton = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.primary};
  padding: ${RFValue(12)}px ${RFValue(24)}px;
  border-radius: ${RFValue(30)}px;
`;

export const RefreshButtonText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
`;

export const SupportOverlay = styled.View`
  flex: 1;
  background-color: rgba(0, 0, 0, 0.8);
  justify-content: center;
  padding: 0 24px;
  align-items: center;
`;

export const SupportModalCard = styled.View`
  width: 100%;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(16)}px;
  overflow: hidden;
`;

export const SupportHeaderRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: ${RFValue(12)}px ${RFValue(16)}px;
`;

export const SupportCloseButton = styled.TouchableOpacity`
  padding: ${RFValue(6)}px;
  margin-left: -${RFValue(6)}px;
`;

export const SupportCloseIcon = styled(Icon).attrs(({theme}) => ({
  name: 'x',
  size: RFValue(18),
  color: theme.colors.text,
}))``;

export const SupportModalContent = styled.View`
  padding: ${RFValue(16)}px;
`;

export const SupportTitle = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(16)}px;
  text-align: left;
  margin-bottom: ${RFValue(8)}px;
`;

export const SupportDescription = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  text-align: left;
  line-height: ${RFValue(18)}px;
`;

export const SupportActions = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: ${RFValue(24)}px;
`;

export const SupportConfirmButton = styled.TouchableOpacity`
  border-radius: ${RFValue(8)}px;
  padding: ${RFValue(12)}px ${RFValue(18)}px;
  background-color: ${({theme}) => theme.colors.primary};
  width: 100%;
  align-items: center;
`;

export const SupportConfirmText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(13)}px;
  text-align: center;
`;

export const SupportInputLabel = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.bold};
  margin-top: ${RFValue(16)}px;
`;

export const SupportInputCounter = styled.Text`
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
  text-align: right;
  margin-top: ${RFValue(4)}px;
`;

export const SupportInput = styled.TextInput`
  border-style: solid;
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.border};
  margin-top: ${Platform.OS === 'ios' ? RFValue(8) : 0};
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  min-height: ${RFValue(32)}px;
`;
